import React, { FC, useRef, useState } from "react";
import { Empty, Mentions, message, Typography } from "antd";
import { validation, data } from "../../../constants";
import {
  Wrapper,
  InputComment,
  SendIconContainer,
  DateTime,
  InputArea,
  CommentWrapper,
  Header,
  CommentsWrapper,
  LoaderContainer,
  MentionInputWrapper,
  AttachFileWrapper,
  InputDocumentWrapper,
} from "./elements";
import { Loader } from "../../atoms/Loader";
import { CommentProps } from "./types";
import { Comment as CommentType } from "../../../core/entities/comment";
import moment from "moment";
import Icon from "@ant-design/icons";
import { Mention, MentionsInput } from "react-mentions";
import { RootStateOrAny, useSelector } from "react-redux";
import { ButtonWithIcon } from "../../atoms/Button";
import { hasExtension } from "../../../utils/helpers/file";
import { ReactComponent as ClipComponent } from '../../../assets/icons/clip.svg';
import { ReactComponent as SendArrowComponent } from "../../../assets/icons/send-arrow.svg";
const { Title, Text } = Typography;

const SendIcon = (props: any) => <Icon component={SendArrowComponent} {...props} />;
const ClipIcon = (props: any) => <Icon component={ClipComponent} {...props} />;

const Comment: FC<CommentProps> = (props) => {
  const { onComment, comments, value, onChange, isCommentsLoading, searchUser, isUsersLoading, onUploadApplicantDocuments, isUploadApplicantDocumentsLoading } = props;
  const [isCommentFocused, setIsCommentFocused] = useState(false);

  const inputDocument = useRef<HTMLInputElement>(null);
  const users = useSelector((state: RootStateOrAny) => state.user.searchedUsers);

  const handleDisplayUser = (query: any, callback: any) => {
    if (searchUser) {
      searchUser(query);

      if (users && !isUsersLoading) {
        return callback(users.map(({ id, name }: any) => ({ id, display: name })));
      }
    }

    return [];
  }

  const openDocumentUpload = (e: any) => {
    e.currentTarget.blur();
    e.preventDefault();
    inputDocument?.current?.click();
  };

  const onUploadDocument = async (e: any) => {
    message.config({ duration: 1.5, maxCount: 1 });
    const targetFile = e.target.files[0];

    if (!hasExtension(targetFile, validation.validFileExtensions)) {
      message.error("File is not valid");
    }

    if (targetFile) {
      if (targetFile.size > data.maximumDocumentFileSize) {
        message.error("File size too large");
      } else {
        onUploadApplicantDocuments(targetFile, targetFile.name);
      }
    }
    e.currentTarget.value = null;
  };

  const getMentionedUser = (comment: string) => {
    const text = comment.replaceAll(/{{/g, "<span style='background: #1877f233;padding:5px;border-radius:5px;font-weight:bold'>").replaceAll(/}}/g, "</span>");

    return text;
  }

  const onPressEnter = (event: any) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      onComment(event);
    }
  }

  return (
    <Wrapper>
      <InputArea>
        <Header>Comments</Header>
        <MentionInputWrapper style={{ position: "relative" }}>
          <MentionsInput rows={4} cols={10} onChange={onChange} onBlur={() => setIsCommentFocused(false)} onFocus={() => setIsCommentFocused(true)} onKeyDown={onPressEnter} value={value} placeholder="Comment here..." className="mentions">
            <Mention markup="{{__display__}}" className="mentions__mention" data={handleDisplayUser} trigger="@" />
          </MentionsInput>
          {/* <InputComment
            value={value}
            onChange={onChange}
            placeholder="Comment here..."
            autoSize={{ minRows: 4, maxRows: 4 }}
            onPressEnter={onPressEnter}
          /> */}
          <SendIconContainer style={{ color: isCommentFocused ? ' #00918E' : '' }} onClick={onComment}>
            <Icon component={() => <SendIcon style={{ fontSize: "32px" }} />} />
          </SendIconContainer>
        </MentionInputWrapper>
        <AttachFileWrapper>
          {
            isUploadApplicantDocumentsLoading ?
              <Loader /> 
              : (
                <>
                  <InputDocumentWrapper
                    type="file"
                    onChange={onUploadDocument}
                    ref={inputDocument}
                    accept={validation.resumeFileExtensions}
                  />
                  <ButtonWithIcon $isPrimary icon={<ClipIcon style={{ fontSize: "14px", marginTop: "2px" }} />} onClick={openDocumentUpload}>
                    Attach File
                  </ButtonWithIcon>
                </>
              )
          }
        </AttachFileWrapper>
      </InputArea>
      {isCommentsLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <CommentsWrapper>
          {comments && comments.length ? (
            comments.map((comment: CommentType, index: number) => (
              <CommentWrapper key={index}>
                <Title level={5}>
                  {comment.commentor} -{" "}
                  <DateTime>{`${moment(comment.dateTime).format(
                    "MM/DD/YYYY hh:mm a"
                  )}`}</DateTime>
                </Title>
                <span style={{ wordBreak: 'break-all' }} dangerouslySetInnerHTML={{ __html: getMentionedUser(comment.comment) }}></span>
                {/* <Text>{getMentionedUser(comment.comment)}</Text> */}
              </CommentWrapper>
            ))
          ) : (
            <Empty />
          )}
        </CommentsWrapper>
      )}
    </Wrapper>
  );
};

export default Comment;
